/**
 * @generated SignedSource<<2a7c9b53938cf863b6f42363b13db5fc>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment, RefetchableFragment } from 'relay-runtime';
export type CalendarSource = "google" | "internal" | "office365";
export type ConferenceProviderOptions = "GOOGLE" | "NONE" | "TEAMS" | "ZOOM";
import { FragmentRefs } from "relay-runtime";
export type useConferencingOptions_viewer$data = {
  readonly calendars: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly source: CalendarSource;
      };
    }>;
  };
  readonly defaultConferenceProvider: ConferenceProviderOptions;
  readonly id: string;
  readonly integrations: {
    readonly zoom: {
      readonly hasMeetingWriteScope: boolean;
      readonly id: string;
    } | null;
  };
  readonly user: {
    readonly id: string;
  };
  readonly " $fragmentType": "useConferencingOptions_viewer";
};
export type useConferencingOptions_viewer$key = {
  readonly " $data"?: useConferencingOptions_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"useConferencingOptions_viewer">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "refetch": {
      "connection": null,
      "fragmentPathInResult": [
        "viewer"
      ],
      "operation": require('./useConferencingOptionsRefreshQuery.graphql')
    }
  },
  "name": "useConferencingOptions_viewer",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "defaultConferenceProvider",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "user",
      "plural": false,
      "selections": [
        (v0/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "UserIntegrations",
      "kind": "LinkedField",
      "name": "integrations",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ZoomUserNode",
          "kind": "LinkedField",
          "name": "zoom",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasMeetingWriteScope",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "CalendarConnection",
      "kind": "LinkedField",
      "name": "calendars",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "CalendarEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Calendar",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "source",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
})();

(node as any).hash = "ef69d3681d846460dc7b5654cb690923";

export default node;
